var map = {
  "./dashboard.svg": "96204",
  "./example.svg": "76994",
  "./eye-open.svg": "12984",
  "./eye.svg": "15287",
  "./form.svg": "62058",
  "./home.svg": "64285",
  "./link.svg": "47128",
  "./message.svg": "40621",
  "./money.svg": "70428",
  "./nested.svg": "37153",
  "./password.svg": "63995",
  "./peoples.svg": "49512",
  "./shopping.svg": "30604",
  "./table.svg": "7212",
  "./tree.svg": "91568",
  "./user.svg": "74057"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13891;
